import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { ReadService } from './read.service';
import { ICustomerInvoice } from '../interfaces/customer-invoice';
import { ICustomerInvoiceFilter } from '../interfaces/customer-invoice-filter';
import { ICustomerPriority, ICustomerPriorityCreate } from '../interfaces/department';
import { ICustomerPriorityFilter } from '../interfaces/customer-priority-filter';

@Injectable({ providedIn: 'root' })
export class CustomerPriorityService extends ReadService<
  ICustomerPriority,
  ICustomerPriorityFilter
> {
  url = '/api/customer-priority';
  entityTitle = '';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  getCustomerPriority(id: number) {
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/${id}`),
      this.handlersFactory.getForReadAll(),
    );
  }

  upsert(dto: ICustomerPriorityCreate) {
    return this.handleRequest(
      this.http.post<ICustomerPriority>(`${this.url}`, dto),
      this.handlersFactory.getForReadAll(),
    );
  }

  delete(id: number) {
    return this.handleRequest(
      this.http.delete<any[]>(`${this.url}/${id}`),
      this.handlersFactory.getForReadAll(),
    );
  }

  search() {
    return this.handleRequest(
      this.http.get<any[]>(`${this.url}/customer-priorities`),
      this.handlersFactory.getForReadAll(),
    );
  }
}
